export default __webpack_public_path__ + "static/media/perfil.c9a01753.svg";